module.exports = __webpack_public_path__ + "img/3-3.5dec3a44.jpg";